import React, { useEffect, useState } from 'react';

const TypingEffect = ({ text, speed = 15, onComplete }) => {
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        let index = 0;
        let interval;

        const startTyping = () => {
            interval = setInterval(() => {
                index++;
                setDisplayedText(text.slice(0, index));
                if (index >= text.length) {
                    clearInterval(interval);
                    onComplete?.();
                }
            }, speed);
        };

        setDisplayedText('');
        // Wait one tick to reset before typing starts
        const timeout = setTimeout(startTyping, speed);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [text]);

    return <div className="ch-ai-typing-container">{displayedText}</div>;
};

export default TypingEffect;
